import axios, { AxiosResponse } from 'axios';
import { PATH } from 'routes/constant';
import { openWhatsappToUrl } from './handleSendMessageWhatsapp';
import utils from './utils';
import { IUserDetail } from './style_item';
// import utils from './utils';

export const fetchImageForShare = async (image: string) => {
    try {
        // let image = 'https://www.net-a-porter.com/variants/images/27086482324142210/in/w1365_q60.jpg'
        let fileName = new URL(image)?.pathname.split('/').pop();
        // console.log("fileName", new URL(img).pathname);

        if (!fileName) {
            fileName = 'image.jpg';
        }
        const corsUrl = utils.getCorsUrl(image);

        console.log('corsUrl', corsUrl);

        const response: AxiosResponse<Blob> = await axios.get(corsUrl, {
            responseType: 'blob',
            timeout: 5000,
        });
        const blob = response.data;

        if (!fileName!.endsWith('.jpg') && !fileName!.endsWith('.jpeg') && !fileName!.endsWith('.png')) {
            const extension = blob.type.split('/').pop();
            fileName = `${fileName}.${extension}`;
        }

        // replace jpeg extension with jpg
        if (fileName!.endsWith('.jpeg')) {
            fileName = fileName!.replace('.jpeg', '.jpg');
        }

        let file: File = new File([blob], fileName + '.jpg', {
            type: blob.type,
            lastModified: new Date().getTime(),
        });
        return file;
    } catch (error) {
        console.error(error);
        return null;
    }
};

export const nativeImageShare = async (data: { image?: File; text: string; url: string; title?: string }) => {
    // data.image = "https://images.pexels.com/photos/9424433/pexels-photo-9424433.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500"

    const { image, text, title } = data;

    if (!navigator.share) {
        throw new Error('Native share is not supported');
    }

    let files: File[] = [];

    if (image) {
        // files = await fetchImage(image);
        files.push(image);
    }

    let shareData: ShareData = {};

    if (
        navigator.canShare({
            text,
        })
    ) {
        shareData.text = text;
    }

    // if (navigator.canShare({ url })) {
    //     shareData.url = url;
    // }

    if (
        navigator.canShare({
            files,
        })
    ) {
        shareData.files = files;
        shareData.text = shareData.text ? shareData.text + '\n' : undefined;
    }

    if (
        title &&
        navigator.canShare({
            title,
        })
    ) {
        shareData.title = title;
    }

    navigator.share(shareData).catch((error) => console.error(error));
};

export const whatsAppShare = async (text: string) => {
    return openWhatsappToUrl(text);
};

export const shareMail = async (text: string, subject = '') => {
    const url = `mailto:?body=${encodeURIComponent(text)}&subject=${encodeURIComponent(subject)}`;
    return window.open(url, '_blank');
};

export const getStyleUrl = (item: any) => {
    const cd = item?.contextDetail;
    const itemData = item?.data;
    if (cd?.contextType === 'style' && cd?.contextTaffiId) {
        return `${PATH.STYLE_DETAIL}/${cd?.contextTaffiId}`;
    } else if (!cd && itemData.taffiId) {
        return `${PATH.ITEM_DETAIL}/${itemData.taffiId}`;
    }
    return PATH.PATH_NOT_FOUND;
};

export const copyToClipboard = async (text: string) => {
    if (!navigator?.clipboard) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand('copy');
        document.body.removeChild(textArea);
    } else {
        navigator.clipboard.writeText(text);
    }
};

export const copyToClipboardAsync = (text: string, isUsingDom: boolean = false) => {
    return new Promise((resolve, reject) => {
        const copyUsingDom = () => {
            const textArea = document.createElement('textarea');
            textArea.value = text;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            resolve(true);
        };
        if (navigator?.clipboard?.writeText && !isUsingDom) {
            navigator.clipboard
                .writeText(text)
                .then(() => {
                    resolve(true);
                })
                .catch(() => copyUsingDom());
        } else {
            copyUsingDom();
        }
    });
};

export const createShareMessage = (label: string, url: string, userDetail: IUserDetail) => {
    let message = `Hey,\n\nCheck out this cool ${label} on Taffi: ${url} ${
        userDetail ? `\n\n- ${userDetail?.firstName} ${userDetail?.lastName}` : ''
    }`;
    return message;
};

export const shareStyle = async (
    title: string,
    shareMessageLabel: string,
    url: string,
    userDetail: IUserDetail,
    shareImage: File | null,
) => {
    if (!!navigator?.share) {
        await nativeImageShare({
            text: title + '\n\n' + createShareMessage(shareMessageLabel, url, userDetail),
            url: url,
            image: shareImage!,
            title: title,
        });
    }
};

export const getShareImage = async (
    url: string,
    setFetchImageLoading: (val: boolean) => void,
    setFetchedImage: (val: File | null) => void,
) => {
    try {
        setFetchImageLoading(true);
        const imageFile = await fetchImageForShare(url);
        setFetchedImage(imageFile as File);
    } catch (error) {
        console.error(error);
    } finally {
        setFetchImageLoading(false);
    }
};
